<template>
  <div>
    <div class="flex flex-col items-center justify-center p-4 max-w-25rem">
      <slot name="icon">
        <div :class="['iconfont', icon]" class="transform scale-200 mb-6"></div>
      </slot>
      <div class="text-base font-bold mb-2">
        <slot name="title">title</slot>
      </div>
      <div class="text-sm text-gray-500">
        <slot name="detail">detail</slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    icon: String,
  },
  setup() {
    return {}
  },
}
</script>

<style scoped lang="scss"></style>
